/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTournamentsRegisterTeamMutationRequest,
  PostTournamentsRegisterTeamMutationResponse,
  PostTournamentsRegisterTeam400,
  PostTournamentsRegisterTeam401,
  PostTournamentsRegisterTeam403,
  PostTournamentsRegisterTeam500,
} from "../types/PostTournamentsRegisterTeam.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTournamentsRegisterTeamMutationKey = () =>
  [{ url: "/tournaments/register/team" }] as const;

export type PostTournamentsRegisterTeamMutationKey = ReturnType<
  typeof postTournamentsRegisterTeamMutationKey
>;

/**
 * @description Используется для турниров с типом Classic.
 * Команда должна быть предварительно создана и иметь необходимое количество участников.
 * @summary Регистрация готовой команды на турнир (Classic Mode)
 * {@link /tournaments/register/team}
 */
export async function postTournamentsRegisterTeam(
  data: PostTournamentsRegisterTeamMutationRequest,
  config: Partial<RequestConfig<PostTournamentsRegisterTeamMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostTournamentsRegisterTeamMutationResponse,
    ResponseErrorConfig<
      | PostTournamentsRegisterTeam400
      | PostTournamentsRegisterTeam401
      | PostTournamentsRegisterTeam403
      | PostTournamentsRegisterTeam500
    >,
    PostTournamentsRegisterTeamMutationRequest
  >({
    method: "POST",
    url: `/tournaments/register/team`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function postTournamentsRegisterTeamMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostTournamentsRegisterTeamMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postTournamentsRegisterTeamMutationKey();
  return mutationOptions<
    ResponseConfig<PostTournamentsRegisterTeamMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterTeam400
      | PostTournamentsRegisterTeam401
      | PostTournamentsRegisterTeam403
      | PostTournamentsRegisterTeam500
    >,
    { data: PostTournamentsRegisterTeamMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postTournamentsRegisterTeam(data, config);
    },
  });
}

/**
 * @description Используется для турниров с типом Classic.
 * Команда должна быть предварительно создана и иметь необходимое количество участников.
 * @summary Регистрация готовой команды на турнир (Classic Mode)
 * {@link /tournaments/register/team}
 */
export function usePostTournamentsRegisterTeam<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTournamentsRegisterTeamMutationResponse>,
      ResponseErrorConfig<
        | PostTournamentsRegisterTeam400
        | PostTournamentsRegisterTeam401
        | PostTournamentsRegisterTeam403
        | PostTournamentsRegisterTeam500
      >,
      { data: PostTournamentsRegisterTeamMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostTournamentsRegisterTeamMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTournamentsRegisterTeamMutationKey();

  const baseOptions = postTournamentsRegisterTeamMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTournamentsRegisterTeamMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterTeam400
      | PostTournamentsRegisterTeam401
      | PostTournamentsRegisterTeam403
      | PostTournamentsRegisterTeam500
    >,
    { data: PostTournamentsRegisterTeamMutationRequest },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTournamentsRegisterTeamMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterTeam400
      | PostTournamentsRegisterTeam401
      | PostTournamentsRegisterTeam403
      | PostTournamentsRegisterTeam500
    >,
    { data: PostTournamentsRegisterTeamMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTournamentsRegisterTeamMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterTeam400
      | PostTournamentsRegisterTeam401
      | PostTournamentsRegisterTeam403
      | PostTournamentsRegisterTeam500
    >,
    { data: PostTournamentsRegisterTeamMutationRequest },
    TContext
  >;
}
